import { SegmentPhase } from './constants'

export const isOpenLadder = (segment) => {
	return segment?.configuration?.phase === SegmentPhase.OPEN_LADDER
}

export const isMonthlyQualifier = (segment) => {
	return segment?.configuration?.phase === SegmentPhase.MONTHLY_QUALIFIERS
}

export const isMonthlyFinal = (segment) => {
	return segment?.configuration?.phase === SegmentPhase.MONTHLY_FINALS
}
